import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class TabletMpProvider {
  public static async hide(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Client.Responses.TabletHideResponse>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.TabletHideRequest,
      typeof RegionShared.Client.Responses.TabletHideResponse
    >(RegionShared.Client.Events.Tablet.Hide, {});
  }

  public static async launchMarketplaceApp(): Promise<
    RpcMpProviderFailedResponse | RpcMpProviderSuccessResponse<boolean>
  > {
    return RpcMpProvider.getInstance().callClient<
      typeof RegionShared.Client.Requests.MarketplaceShowRequest,
      typeof RegionShared.Client.Responses.MarketplaceShowResponse
    >(RegionShared.Client.Events.Marketplace.MarketplaceShow, {});
  }
}
